import { render, staticRenderFns } from "./UiTabs.vue?vue&type=template&id=7ccbbcdc"
import script from "./UiTabs.vue?vue&type=script&lang=js"
export * from "./UiTabs.vue?vue&type=script&lang=js"
import style0 from "./UiTabs.vue?vue&type=style&index=0&id=7ccbbcdc&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports